module.exports = __webpack_public_path__ + "static/media/mapCastle.659d4f2f.jpg";